import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-proyecciones',
  templateUrl: './proyecciones.component.html',
  styleUrls: ['./proyecciones.component.css']
})
export class ProyeccionesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
